import request from '@/plugin/axios'

export function getPublishedTemplates () {
  return request({ url: request.adornUrl('/pxArchive/template/published'), method: 'get' })
}

export function getTemplateMetrics (id) {
  return request({ url: request.adornUrl(`/pxArchive/template/${id}/metrics`), method: 'get' })
}

export function getBatchPage (params) {
  return request({ url: request.adornUrl('/pxArchive/batch/page'), method: 'get', params })
}

export function getBatch (id) {
  return request({ url: request.adornUrl(`/pxArchive/batch/${id}`), method: 'get' })
}

export function saveBatch (data) {
  return request({ url: request.adornUrl('/pxArchive/batch/save'), method: 'post', data })
}

export function publishBatch (id) {
  return request({ url: request.adornUrl(`/pxArchive/batch/${id}/publish`), method: 'post' })
}

export function reconcileTasks (batchId) {
  return request({ url: request.adornUrl(`/pxArchive/task/batch/${batchId}/reconcile`), method: 'post' })
}

export function getTaskPage (params) {
  return request({ url: request.adornUrl('/pxArchive/task/page'), method: 'get', params })
}

export function assignTasks (data) {
  return request({ url: request.adornUrl('/pxArchive/task/assign'), method: 'post', data })
}

export function getTaskDetail (id, params) {
  return request({ url: request.adornUrl(`/pxArchive/workbench/task/${id}`), method: 'get', params })
}

export function saveDraft (data) {
  return request({ url: request.adornUrl('/pxArchive/workbench/draft'), method: 'post', data })
}

export function submitEvaluation (data) {
  return request({ url: request.adornUrl('/pxArchive/workbench/submit'), method: 'post', data })
}

export function reviseEvaluation (id, data) {
  return request({ url: request.adornUrl(`/pxArchive/evaluation/${id}/revise`), method: 'post', data })
}

export function getEvaluationPage (params) {
  return request({ url: request.adornUrl('/pxArchive/evaluation/page'), method: 'get', params })
}

export function getEvaluationDetail (id) {
  return request({ url: request.adornUrl(`/pxArchive/evaluation/${id}`), method: 'get' })
}

export function voidEvaluation (id, reason) {
  return request({ url: request.adornUrl(`/pxArchive/evaluation/${id}/void`), method: 'post', data: { reason } })
}

export function getStudentArchive (memberId, params) {
  return request({
    url: request.adornUrl(`/pxArchive/student/archive/${memberId}`),
    method: 'get',
    params
  })
}

export function getStudentPage (params) {
  return request({ url: request.adornUrl('/pxArchive/student/archive/page'), method: 'get', params })
}

export function getStudentTrend (memberId) {
  return request({ url: request.adornUrl(`/pxArchive/student/archive/${memberId}/trend`), method: 'get' })
}

export function getTemplatePage (params) {
  return request({ url: request.adornUrl('/pxArchive/template/page'), method: 'get', params })
}

export function getTemplateDetail (id) {
  return request({ url: request.adornUrl(`/pxArchive/template/${id}`), method: 'get' })
}

export function saveTemplate (data) {
  return request({ url: request.adornUrl('/pxArchive/template'), method: 'post', data })
}

export function updateTemplate (id, data) {
  return request({ url: request.adornUrl(`/pxArchive/template/${id}`), method: 'put', data })
}

export function publishTemplate (id) {
  return request({ url: request.adornUrl(`/pxArchive/template/${id}/publish`), method: 'post' })
}

export function disableTemplate (id) {
  return request({ url: request.adornUrl(`/pxArchive/template/${id}/disable`), method: 'post' })
}

export function copyTemplate (id) {
  return request({ url: request.adornUrl(`/pxArchive/template/${id}/copy`), method: 'post' })
}

export function startBatch (id) {
  return request({ url: request.adornUrl(`/pxArchive/batch/${id}/start`), method: 'post' })
}

export function finishBatch (id) {
  return request({ url: request.adornUrl(`/pxArchive/batch/${id}/finish`), method: 'post' })
}

export function cancelBatch (id) {
  return request({ url: request.adornUrl(`/pxArchive/batch/${id}/cancel`), method: 'post' })
}

export function exportEvaluations (params) {
  return request({ url: request.adornUrl('/pxArchive/evaluation/export'), method: 'get', params, responseType: 'blob' })
}
